import * as ContextMenu from "zeego/context-menu";
import { MenuContent } from "~/components/menu/MenuContent";
import { MenuItem } from "~/components/menu/MenuItem";
import { MenuItemIcon } from "~/components/menu/MenuItemIcon";
import { MenuItemTitle } from "~/components/menu/MenuItemTitle";

export const MenuRoot = ContextMenu.Root;
export const MenuTrigger = ContextMenu.Trigger;

export { MenuContent, MenuItem, MenuItemTitle, MenuItemIcon };
